<template>
  <div class="cover-section">
    <div class="d-flex align-center justify-space-between flex-md-row flex-column">
      <div>
        <div class="text-h2 text-center font-weight-bold py-3">{{ $t('home.cover.title') }}</div>
        <div class="text-h5 text-center grey--text py-3">{{ $t('home.cover.subtitle') }}</div>
        <div class="d-flex justify-center py-6 pb-3">
          <v-btn color="primary" x-large class="mx-auto" elevation="0" to="/cadastrar">{{ $t('home.cover.cta') }}<v-icon
              small class="ml-12">mdi-arrow-right</v-icon></v-btn>
        </div>
        <div class="d-flex justify-space-between align-center py-6 pb-3 flex-column flex-md-row">
          <div class="mx-3 mb-6 mb-md-0" style="width: 100%; max-width: 400px;">
            <img :src="logoCda" alt="Logo">
            <div style="font-size: 1.3em;" class="text-center text-md-left grey--text py-3">{{ $t('home.applications.cda') }}</div>
          </div>

          <div class="mx-3" style="width: 100%; max-width: 400px;">
            <img :src="logoCdm" alt="Logo">
            <div style="font-size: 1.3em;" class="text-center text-md-right grey--text py-3">{{ $t('home.applications.cdm') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CoverSection",
  data() {
    return {

      logoCda: require('@/assets/images/cda.svg'),
      logoCdm: require('@/assets/images/cdm.svg'),
    }
  }
}
</script>

<style scoped>
@media (max-width: 500px) {
  .text-h2 {
    font-size: 2rem !important;
  }
  
  .text-h5 {
    font-size: 1.25rem !important;
  }
}
</style>